import React from 'react';
import { HeartCrackIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-16 px-4 bg-white" data-id="element-76">
      <div className="max-w-4xl mx-auto" data-id="element-77">
        <div className="text-center mb-12" data-id="element-78">
          <HeartCrackIcon className="mx-auto text-rose-500 mb-4" size={48} data-id="element-79" />
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-80">
            Cuando tu hijo deja de hablar español… no pierdes un idioma.
            <span className="text-rose-600" data-id="element-81"> Pierdes una conexión.</span>
          </h2>
        </div>

        <div className="prose prose-lg max-w-none text-gray-700 space-y-6" data-id="element-82">
          <p className="text-xl leading-relaxed" data-id="element-83">
            El español es más que palabras. Es el idioma de tus recuerdos, de
            tus abuelos, de los chistes familiares, de la comida, de tu
            infancia.
          </p>

          <p className="text-xl leading-relaxed" data-id="element-84">
            Por eso, cuando tus hijos responden en inglés, o te dicen:
            <span className="italic font-semibold" data-id="element-85">
              {' '}
              "Mom, don't speak Spanish"
            </span>
            , no te duele la gramática.{' '}
            <span className="font-bold text-rose-600" data-id="element-86">
              Te duele el corazón.
            </span>
          </p>

          <div className="bg-rose-50 p-8 rounded-lg my-8 border-l-4 border-rose-500" data-id="element-87">
            <ul className="space-y-4 text-lg" data-id="element-88">
              <li data-id="element-89">
                💔 Te duele imaginar que un día no podrán hablar con tus padres.
              </li>
              <li data-id="element-90">💔 Te duele sentir que tu cultura se está diluyendo.</li>
              <li data-id="element-91">
                💔 Te pesa la culpa de pensar: "Creo que no hice suficiente…
                ¿será demasiado tarde?"
              </li>
            </ul>
          </div>

          <p className="text-2xl font-bold text-center text-gray-900 mt-8" data-id="element-92">
            Respira. No es culpa tuya. Y sí estás a tiempo.
          </p>
        </div>
      </div>
    </section>;
}